import { FC } from "react";

import styles from "./chartLoader.module.scss";

const ChartLoader: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default ChartLoader;